import { RoomType } from 'pages/common/types';
import { TProjectConfigurationParameter } from '../../entries/common/widgets/project-configuration/context';

export enum ParametersEnum {
  doorType = 'doorType',
  colour = 'colour',
  forWetRooms = 'forWetRooms',
}

export enum DoorType {
  GLASS = 'GLASS',
  BLANK = 'BLANK',
  GLAZED = 'GLAZED',
}

export enum ForWetRoomsType {
  YES = 'true',
  NO = 'false',
}

export enum ColourType {
  WHITE = 'WHITE',
  BEIGE = 'BEIGE',
  SILVER = 'SILVER',
  BROWN = 'BROWN',
  BLACK = 'BLACK',
  YELLOW = 'YELLOW',
  GREEN = 'GREEN',
}

export type Inputs = {
  doorType: Array<DoorType> | null;
  colour: Array<ColourType> | null;
  forWetRooms: ForWetRoomsType | null;
};

export type TGetIcon = {
  isSmall: boolean;
};

export type LaminateInputs = {
  width: string | null;
  length: string | null;
  layingType: string | null;
  area: string | null;
  roomType: RoomType | 'any';
};

export type TCreateConfigurationBody = {
  configurationType: string;
  buCode: number;
  currency: string;
  projectConfigurationParameters: Array<TProjectConfigurationParameter>;
  customerId: string;
  isAuthorized: boolean;
};

export type TEditConfigurationBody = {
  projectConfigurationParameters: Array<TProjectConfigurationParameter>;
};
